import Vue from "vue";

Vue.directive("window-resize", {
  bind(el, binding) {
    if (typeof binding.value === "function") {
      window.addEventListener("resize", binding.value);
    }
  },
  unbind(el, binding) {
    if (typeof binding.value === "function") {
      window.removeEventListener("resize", binding.value);
    }
  },
});
